<template>
  <div></div>
</template>

<script>
export default {
  name: 'YunoRedirectView',

  created() {
    const originalURL = decodeURIComponent(this.$route.params.url)
    window.parent.location = `${originalURL}`
  }
}
</script>